export const iconNameList = [
    "Accept",
    "Add",
    "AddTo",
    "AddFriend",
    "AddGroup",
    "AddMedium",
    "Airplane",
    "AllApps",
    "AppIconDefaultAdd",
    "Apps",
    "AskAParent",
    "Back",
    "BingLogo",
    "BirthdayCake",
    "Blocked",
    "BoardActivityFeed",
    "BrokenFile",
    "BulletedList",
    "BumperLeft",
    "BumperRight",
    "ButtonA",
    "ButtonB",
    "ButtonX",
    "ButtonY",
    "Calendar",
    "CalendarReply",
    "Camera",
    "Cancel",
    "Car",
    "CellPhone",
    "CellPhonePermissions",
    "CheckMark",
    "ChevronDown",
    "ChevronDownMed",
    "ChevronDownSmall",
    "ChevronLeft",
    "ChevronLeftSmall",
    "ChevronRight",
    "ChevronRightSmall",
    "ChevronUpMed",
    "ChevronUpSmall",
    "ChevronRightMed",
    "ChevronLeftMed",
    "ChromeClose",
    "ChromeMaximize",
    "ChromeMinimize",
    "CircleFill",
    "CircleFillBadge12",
    "CircleRing",
    "CityNext2",
    "Clock",
    "Cloud",
    "CloudUpload",
    "Completed",
    "CompletedSolid",
    "Contact",
    "ContactCircle",
    "ContactSolid",
    "ConvertTo",
    "Copy",
    "CriticalErrorSolid",
    "DateTime",
    "DefenderApp",
    "Delete",
    "DeviceFamily",
    "DeviceLaptopNoPic",
    "Devices",
    "Devices2",
    "Devices3",
    "DeviceTag",
    "Diagnostic",
    "Diamond",
    "DisconnectDevice",
    "Download",
    "DpadDown",
    "DpadLeft",
    "DpadRight",
    "DpadUp",
    "EditListPencil",
    "Education",
    "Error",
    "ErrorBadge",
    "Family",
    "FamilySafety",
    "Favicon",
    "FavoriteStar",
    "Feedback",
    "FileExplorer",
    "FilterAlt",
    "Financial",
    "Flag",
    "Forward",
    "FullCircleMask",
    "Game",
    "GenericApp",
    "Giftbox",
    "GitHubLogo",
    "Globe",
    "Group",
    "HardDrive",
    "Headset",
    "Health",
    "Heart",
    "HeartBroken",
    "Help",
    "Hide",
    "History",
    "Home",
    "HourGlass",
    "ImageOff",
    "Important",
    "Info",
    "InfoSolid",
    "InkingColorOutline",
    "Insights",
    "Installation",
    "InternetSharing",
    "Jogging",
    "LaptopSecure",
    "LaptopSelected",
    "Leisure",
    "Link",
    "LinkedInLogo",
    "LocaleLanguage",
    "Lock",
    "Mail",
    "Manage",
    "MapPin",
    "Media",
    "Message",
    "Microphone",
    "Microsoft365Logo",
    "MicrosoftLogo",
    "MobBattery0",
    "MobBattery1",
    "MobBattery2",
    "MobBattery3",
    "MobBattery4",
    "MobBattery5",
    "MobBattery6",
    "MobBattery7",
    "MobBattery8",
    "MobBattery9",
    "MobBattery10",
    "Money",
    "More",
    "MoreVertical",
    "MultiplayerJoinChallenge",
    "MyMoviesTV",
    "MyNetwork",
    "NavigateExternalInline",
    "OfficeLogo",
    "OneDriveLogo",
    "OpenInNewWindow",
    "OutlookLogoInverse",
    "PassiveAuthentication",
    "Pause",
    "PaymentCard",
    "PaymentCardArt128",
    "PC1",
    "PeopleSettings",
    "Permissions",
    "Photo2",
    "PhotosApp",
    "Photo2Remove",
    "PictureFill",
    "PieSingle",
    "Play",
    "POI",
    "PopExpand",
    "PowerButton",
    "PreviewLink",
    "Print",
    "ProtectedDocument",
    "Pulse",
    "QRCode",
    "RadioBullet",
    "Recent",
    "Refresh",
    "RemoveCircle",
    "Repair",
    "RevealPasswordMedium",
    "RewardsLogo",
    "Ringer",
    "Safe",
    "Savings",
    "ScreenTime",
    "Search",
    "Send",
    "Settings",
    "SettingsApp",
    "SettingsSync",
    "Share",
    "Shield",
    "ShieldTask",
    "ShieldTaskSolid",
    "Shirt",
    "Shop",
    "ShoppingCart",
    "Signin",
    "SignOut",
    "Silver",
    "SkypeLogo",
    "SortDown",
    "SortUp",
    "SpeedHigh",
    "StatusCircle",
    "StatusCircle7",
    "StatusCircleCheckmark",
    "StatusCircleExclamation",
    "StatusCircleOuter",
    "StatusErrorCircle7",
    "StatusErrorFull",
    "StatusWarning",
    "Stop",
    "Stopwatch",
    "StoreLogo16",
    "Street",
    "Subscriptions",
    "Switch",
    "Sync",
    "System",
    "Tablet",
    "TeamsLogo",
    "Ticket",
    "TextSortAscending",
    "TextSortDescending",
    "Toolbox",
    "TriggerLeft",
    "TriggerRight",
    "Trophy",
    "TVMonitor",
    "TwitterLogo",
    "Undo",
    "Unknown",
    "Unlock",
    "UpdateRestore",
    "Video",
    "ViewDashboard",
    "Volume",
    "Warning",
    "WarningSolid",
    "WebSearch",
    "Website",
    "WhatsThis",
    "Wifi",
    "WindowsLogo",
    "Work",
    "XboxController",
    "XboxGamePass",
    "XboxGold",
    "XboxLogo",
    "XboxOneConsole"
] as const;

export const iconNameSet = new Set(iconNameList);

export const IconList: { [K in typeof iconNameList[number]]: { readonly "content": string } } = {
    "Accept": { "content": "E8FB" },
    "Add": { "content": "E710" },
    "AddTo": { "content": "ECC8" },
    "AddFriend": { "content": "E8FA" },
    "AddGroup": { "content": "EE3D" },
    "AddMedium": { "content": "ECA1" },
    "Airplane": { "content": "E709" },
    "AllApps": { "content": "E71D" },
    "AppIconDefaultAdd": { "content": "EFDA" },
    "Apps": { "content": "ED35" },
    "AskAParent": { "content": "F206" },
    "Back": { "content": "E72B" },
    "BingLogo": { "content": "EB6B" },
    "BirthdayCake": { "content": "EF8D" },
    "Blocked": { "content": "E733" },
    "BoardActivityFeed": { "content": "EDF0" },
    "BrokenFile": { "content": "F1E4" },
    "BulletedList": { "content": "E8FD" },
    "BumperLeft": { "content": "F10C" },
    "BumperRight": { "content": "F10D" },
    "ButtonA": { "content": "F093" },
    "ButtonB": { "content": "F094" },
    "ButtonX": { "content": "F096" },
    "ButtonY": { "content": "F095" },
    "Calendar": { "content": "E787" },
    "CalendarReply": { "content": "E8F5" },
    "Camera": { "content": "E722" },
    "Cancel": { "content": "E711" },
    "Car": { "content": "E804" },
    "CellPhone": { "content": "E8EA" },
    "CellPhonePermissions": { "content": "F5E1" },
    "CheckMark": { "content": "E73E" },
    "ChevronDown": { "content": "E70D" },
    "ChevronDownMed": { "content": "E972" },
    "ChevronDownSmall": { "content": "E96E" },
    "ChevronLeft": { "content": "E76B" },
    "ChevronLeftSmall": { "content": "E96F" },
    "ChevronRight": { "content": "E76C" },
    "ChevronRightSmall": { "content": "E970" },
    "ChevronUpMed": { "content": "E971" },
    "ChevronUpSmall": { "content": "E96D" },
    "ChevronRightMed": { "content": "E974" },
    "ChevronLeftMed": { "content": "E973" },
    "ChromeClose": { "content": "E8BB" },
    "ChromeMaximize": { "content": "E922" },
    "ChromeMinimize": { "content": "E921" },
    "CircleFill": { "content": "EA3B" },
    "CircleFillBadge12": { "content": "EDB0" },
    "CircleRing": { "content": "EA3A" },
    "CityNext2": { "content": "EC07" },
    "Clock": { "content": "E917" },
    "Cloud": { "content": "E753" },
    "CloudUpload": { "content": "EC8E" },
    "Completed": { "content": "E930" },
    "CompletedSolid": { "content": "EC61" },
    "Contact": { "content": "E77B" },
    "ContactCircle": { "content": "E77B" },
    "ContactSolid": { "content": "EA8C" },
    "ConvertTo": { "content": "F05C" },
    "Copy": { "content": "E8C8" },
    "CriticalErrorSolid": { "content": "F5C9" },
    "DateTime": { "content": "EC92" },
    "DefenderApp": { "content": "E83D" },
    "Delete": { "content": "E74D" },
    "DeviceFamily": { "content": "F844" },
    "DeviceLaptopNoPic": { "content": "E7F8" },
    "Devices": { "content": "E772" },
    "Devices2": { "content": "E975" },
    "Devices3": { "content": "EA6C" },
    "DeviceTag": { "content": "F6F2" },
    "Diagnostic": { "content": "E9D9" },
    "Diamond": { "content": "ED02" },
    "DisconnectDevice": { "content": "F118" },
    "Download": { "content": "E896" },
    "DpadDown": { "content": "F3DD" },
    "DpadLeft": { "content": "F3DA" },
    "DpadRight": { "content": "F3DB" },
    "DpadUp": { "content": "F3DC" },
    "EditListPencil": { "content": "E668" },
    "Education": { "content": "E7BE" },
    "Error": { "content": "E783" },
    "ErrorBadge": { "content": "EA39" },
    "Family": { "content": "EBDA" },
    "FamilySafety": { "content": "E4B0" },
    "Favicon": { "content": "E737" },
    "FavoriteStar": { "content": "E734" },
    "Feedback": { "content": "ED15" },
    "FileExplorer": { "content": "EC50" },
    "FilterAlt": { "content": "E61A" },
    "Financial": { "content": "E7BB" },
    "Flag": { "content": "E7C1" },
    "Forward": { "content": "E72A" },
    "FullCircleMask": { "content": "E91F" },
    "Game": { "content": "E7FC" },
    "GenericApp": { "content": "EB3B" },
    "Giftbox": { "content": "EC1F" },
    "GitHubLogo": { "content": "F65E" },
    "Globe": { "content": "E774" },
    "Group": { "content": "E902" },
    "HardDrive": { "content": "EDA2" },
    "Headset": { "content": "E95B" },
    "Health": { "content": "E95E" },
    "Heart": { "content": "EB51" },
    "HeartBroken": { "content": "EA92" },
    "Help": { "content": "E897" },
    "Hide": { "content": "ED1A" },
    "History": { "content": "E81C" },
    "Home": { "content": "E80F" },
    "HourGlass": { "content": "EA03" },
    "ImageOff": { "content": "F86A" },
    "Important": { "content": "E8C9" },
    "Info": { "content": "E946" },
    "InfoSolid": { "content": "F167" },
    "InkingColorOutline": { "content": "ED66" },
    "Insights": { "content": "E3AF" },
    "Installation": { "content": "E311" },
    "InternetSharing": { "content": "E704" },
    "Jogging": { "content": "EAD2" },
    "LaptopSecure": { "content": "F552" },
    "LaptopSelected": { "content": "EC76" },
    "Leisure": { "content": "EBF3" },
    "Link": { "content": "E71B" },
    "LinkedInLogo": { "content": "F20A" },
    "LocaleLanguage": { "content": "F2B7" },
    "Lock": { "content": "E72E" },
    "Mail": { "content": "E715" },
    "Manage": { "content": "E912" },
    "MapPin": { "content": "E707" },
    "Media": { "content": "EA69" },
    "Message": { "content": "E8BD" },
    "Microphone": { "content": "E720" },
    "Microsoft365Logo": { "content": "EAA9" },
    "MicrosoftLogo": { "content": "EC6A" },
    "MobBattery0": { "content": "EBA0" },
    "MobBattery1": { "content": "EBA1" },
    "MobBattery2": { "content": "EBA2" },
    "MobBattery3": { "content": "EBA3" },
    "MobBattery4": { "content": "EBA4" },
    "MobBattery5": { "content": "EBA5" },
    "MobBattery6": { "content": "EBA6" },
    "MobBattery7": { "content": "EBA7" },
    "MobBattery8": { "content": "EBA8" },
    "MobBattery9": { "content": "EBA9" },
    "MobBattery10": { "content": "EBAA" },
    "Money": { "content": "EAFD" },
    "More": { "content": "E712" },
    "MoreVertical": { "content": "F2BC" },
    "MultiplayerJoinChallenge": { "content": "EF23" },
    "MyMoviesTV": { "content": "EE6C" },
    "MyNetwork": { "content": "EC27" },
    "NavigateExternalInline": { "content": "F35F" },
    "OfficeLogo": { "content": "EB6E" },
    "OneDriveLogo": { "content": "E941" },
    "OpenInNewWindow": { "content": "E8A7" },
    "OutlookLogoInverse": { "content": "EB6D" },
    "PassiveAuthentication": { "content": "F32A" },
    "Pause": { "content": "E769" },
    "PaymentCard": { "content": "E8C7" },
    "PaymentCardArt128": { "content": "EEF1" },
    "PC1": { "content": "E977" },
    "PeopleSettings": { "content": "F72C" },
    "Permissions": { "content": "E8D7" },
    "PhotosApp": { "content": "E7A9" },
    "Photo2": { "content": "EB9F" },
    "Photo2Remove": { "content": "ECAC" },
    "PictureFill": { "content": "F523" },
    "PieSingle": { "content": "EB05" },
    "Play": { "content": "E768" },
    "POI": { "content": "ECAF" },
    "PopExpand": { "content": "E49A" },
    "PowerButton": { "content": "E7E8" },
    "PreviewLink": { "content": "E8A1" },
    "Print": { "content": "E749" },
    "ProtectedDocument": { "content": "E8A6" },
    "Pulse": { "content": "E660" },
    "QRCode": { "content": "ED14" },
    "RadioBullet": { "content": "E915" },
    "Recent": { "content": "E823" },
    "Refresh": { "content": "E72C" },
    "RemoveCircle": { "content": "E738" },
    "Repair": { "content": "E90F" },
    "RevealPasswordMedium": { "content": "F78D" },
    "RewardsLogo": { "content": "ED4E" },
    "Ringer": { "content": "EA8F" },
    "Safe": { "content": "F540" },
    "Savings": { "content": "EB0B" },
    "ScreenTime": { "content": "F182" },
    "Search": { "content": "E721" },
    "Send": { "content": "E724" },
    "Settings": { "content": "E713" },
    "SettingsApp": { "content": "F0FF" },
    "SettingsSync": { "content": "E359" },
    "Share": { "content": "E72D" },
    "Shield": { "content": "EA18" },
    "ShieldTask": { "content": "F760" },
    "ShieldTaskSolid": { "content": "F761" },
    "Shirt": { "content": "ED00" },
    "Shop": { "content": "E719" },
    "ShoppingCart": { "content": "E7BF" },
    "Signin": { "content": "F286" },
    "SignOut": { "content": "F3B1" },
    "Silver": { "content": "EB0D" },
    "SkypeLogo": { "content": "EB6F" },
    "SortDown": { "content": "EE69" },
    "SortUp": { "content": "EE68" },
    "SpeedHigh": { "content": "EC4A" },
    "StatusCircle": { "content": "EA81" },
    "StatusCircle7": { "content": "F0B6" },
    "StatusCircleCheckmark": { "content": "F13E" },
    "StatusCircleExclamation": { "content": "F13C" },
    "StatusCircleOuter": { "content": "F136" },
    "StatusErrorCircle7": { "content": "F0B8" },
    "StatusErrorFull": { "content": "EB90" },
    "StatusWarning": { "content": "EA84" },
    "Stop": { "content": "E71A" },
    "Stopwatch": { "content": "E916" },
    "StoreLogo16": { "content": "EA96" },
    "Street": { "content": "E913" },
    "Subscriptions": { "content": "ED0F" },
    "Switch": { "content": "E8AB" },
    "Sync": { "content": "E895" },
    "System": { "content": "E770" },
    "Tablet": { "content": "E70A" },
    "TeamsLogo": { "content": "F27B" },
    "Ticket": { "content": "EB54" },
    "TextSortAscending": { "content": "EDC0" },
    "TextSortDescending": { "content": "EDC1" },
    "Toolbox": { "content": "ECED" },
    "TriggerLeft": { "content": "F10A" },
    "TriggerRight": { "content": "F10B" },
    "Trophy": { "content": "EF9A" },
    "TVMonitor": { "content": "E7F4" },
    "TwitterLogo": { "content": "ECB5" },
    "Undo": { "content": "E7A7" },
    "Unknown": { "content": "E9CE" },
    "Unlock": { "content": "E785" },
    "UpdateRestore": { "content": "E777" },
    "Video": { "content": "E714" },
    "ViewDashboard": { "content": "F246" },
    "Volume": { "content": "E767" },
    "Warning": { "content": "E7BA" },
    "WarningSolid": { "content": "F736" },
    "WebSearch": { "content": "F6FA" },
    "Website": { "content": "EB41" },
    "WhatsThis": { "content": "EC23" },
    "Wifi": { "content": "E701" },
    "WindowsLogo": { "content": "E782" },
    "Work": { "content": "E821" },
    "XboxController": { "content": "EB65" },
    "XboxGamePass": { "content": "F1DC" },
    "XboxGold": { "content": "EDEB" },
    "XboxLogo": { "content": "EB70" },
    "XboxOneConsole": { "content": "E990" }
};
